/**
 * WordPress dependencies
 */
import { useMergeRefs } from '@wordpress/compose';
import { forwardRef, useRef } from '@wordpress/element';

/**
 * Internal dependencies
 */
import { ControlWithError } from '../control-with-error';
import RangeControl from '../../range-control';
import { jsx as _jsx } from "react/jsx-runtime";
const UnforwardedValidatedRangeControl = ({
  required,
  customValidity,
  markWhenOptional,
  ...restProps
}, forwardedRef) => {
  const validityTargetRef = useRef(null);
  const mergedRefs = useMergeRefs([forwardedRef, validityTargetRef]);
  return /*#__PURE__*/_jsx(ControlWithError, {
    required: required,
    markWhenOptional: markWhenOptional,
    customValidity: customValidity,
    getValidityTarget: () => validityTargetRef.current,
    children: /*#__PURE__*/_jsx(RangeControl, {
      __next40pxDefaultSize: true,
      __nextHasNoMarginBottom: true,
      ref: mergedRefs,
      ...restProps
    })
  });
};
export const ValidatedRangeControl = forwardRef(UnforwardedValidatedRangeControl);